module.exports = __webpack_public_path__ + "img/308.4de95872.svg";